import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReservationLogin } from "../Services/Service";

const CorporateLogin = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();
  
    const handleLogin = async (e) => {
      e.preventDefault(); // Prevent page reload
      debugger
      const result = await ReservationLogin(email, password);
  
      if (result?.token) {
        navigate("/"); // Redirect to dashboard on success
      } else {
        setError("Invalid login credentials");
      }
    };
  return (
    <main>
    <div className="d-flex align-items-center justify-content-center min-vh-100" >
      <div className="d-flex bg-white p-4 rounded-3 shadow-lg w-75">
        {/* Left Side - Illustration */}
        <div className="w-50 d-flex flex-column justify-content-center align-items-center">
          <img
            src="assets/images/Sign in.svg"
            alt="Illustration"
            className="w-75 "
          />
        </div>


        {/* Right Side - Login Form */}
        <div className="w-50 d-flex flex-column justify-content-center p-4">
          <h2 className="text-center text-dark fw-bold h5">Sign in to start your Corporate session</h2>
          <form className="mt-3" onSubmit={handleLogin}>
            <div className="mb-3">
              <label className="form-label">Username/Email</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter your username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Password</label>
              <input
                type="password"
                className="form-control"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            {/* Show error message if login fails */}
            {error && <div className="text-danger text-center">{error}</div>}

            <button type="submit" className="btn btn-warning w-100 fw-bold">Sign In</button>
          </form>

        </div>
      </div>
    </div>
  </main>
  );
}

export default CorporateLogin;
